import styled from '@emotion/styled';
import React from 'react';
import EmailBodyEditor from './EmailBodyEditor';

interface RequestNotesPropTypes {
  width: number | string;
  value: string;
  marginLeft?: number;
  marginTop?: number;
  onChange: (value: string) => void;
}

const FieldWrapper = styled.div<{
  marginLeft: number;
  marginTop: number;
  width: number | string;
}>`
  margin-top: ${props => props.marginTop}px;
  margin-left: ${props => props.marginLeft}px;
  width: ${props => (typeof props.width === 'number' ? `${props.width}px` : props.width)};
  max-width: 100%;
`;

const FieldLabel = styled.div`
  margin-bottom: 8px;
  color: #444444;
  font-size: 14px;
`;

const RequestNotes = (props: RequestNotesPropTypes) => {
  const handleChange = (value: string) => {
    const normalizedValue = value?.trim() === '<p><br></p>' ? '' : value;
    props.onChange(normalizedValue);
  };

  return (
    <FieldWrapper
      marginLeft={props.marginLeft ?? 76}
      marginTop={props.marginTop ?? 16}
      width={props.width}
    >
      <FieldLabel>Request Notes:</FieldLabel>
      <EmailBodyEditor value={props.value} onDraftChange={handleChange} onCommit={handleChange} />
    </FieldWrapper>
  );
};
export default RequestNotes;
